import { colors } from '../constants';
const styleOverrides = {
  fab: {
    width: 40,
    height: 40,
    backgroundColor: colors.commonColors.white,
    color: colors.text.primary,
    '&:hover': {
      backgroundColor: colors.commonColors.white
    }
  }
};
export default {
  styleOverrides
};
//# sourceMappingURL=MuiSpeedDial.js.map